import GeneralDialog from "../../core/GeneralDialog";

const ResetDialog = (props: ResetDialogProps) => {
  return props.open ? (
    <GeneralDialog
      open={props.open}
      title="編集内容破棄"
      cancelText="編集に戻る"
      saveText="破棄"
      onCancel={() => props.onClose()}
      onSave={() => props.onOk()}
      onClose={() => props.onClose()}
    >
      <div>未保存の内容があります。</div>
      <div>編集した内容を破棄しますか？</div>
    </GeneralDialog>
  ) : (
    <></>
  );
};

export default ResetDialog;

export type ResetDialogProps = {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
};
